import React from "react";
import Field from "../../sections/shared/Field";
import EditorGroup from "../../sections/shared/EditorGroup";

import BackgroundTypeSelector from "../BackgroundTypeSelector";
import LayoutAlignmentSelector from "../LayoutAlignmentSelector";
import FontSelector from "../FontSelector";

export default function CommonDesignSection({
  editedSection,
  t,
  flags,
  alignmentValue,
  setAlignment,
  onStyleChange,
}) {
  const bgMode = editedSection?.style?.bgMode || "default";

  const {
    isHero,
    isFeatures,
    isTestimonials,
    isGallery,
    isCta,
    isCategorySection,
    isLocationSection,
    isServiceSection,
  } = flags;

  const canAlign =
    isHero ||
    isFeatures ||
    isTestimonials ||
    isGallery ||
    isCta ||
    isCategorySection ||
    isLocationSection ||
    isServiceSection;

  return (
    <>
      <EditorGroup
        title={t("sectionModal.background.title", "Background")}
        subtitle={t(
          "sectionModal.background.help",
          "Choose a background style and colors"
        )}
        defaultOpen
      >
        <div className="space-y-4">
          <BackgroundTypeSelector
            value={bgMode}
            onChange={(v) => onStyleChange("bgMode", v)}
            t={t}
          />

          {bgMode === "solid" && (
            <Field
              label={t("sectionModal.background.color", "Background Color")}
              type="color"
              value={editedSection?.style?.bgColor}
              onChange={(v) => onStyleChange("bgColor", v)}
            />
          )}

          {bgMode === "gradient" && (
            <div className="space-y-3 p-4 rounded-xl border border-gray-200 bg-gradient-to-br from-gray-50 to-white">
              <Field
                label={t("sectionModal.background.from", "From Color")}
                type="color"
                value={editedSection?.style?.bgGradientFrom}
                onChange={(v) => onStyleChange("bgGradientFrom", v)}
              />
              <Field
                label={t("sectionModal.background.via", "Via Color (Optional)")}
                type="color"
                value={editedSection?.style?.bgGradientVia}
                onChange={(v) => onStyleChange("bgGradientVia", v)}
              />
              <Field
                label={t("sectionModal.background.to", "To Color")}
                type="color"
                value={editedSection?.style?.bgGradientTo}
                onChange={(v) => onStyleChange("bgGradientTo", v)}
              />
              <Field
                label={t("sectionModal.background.angle", "Angle (0-360)")}
                type="number"
                value={editedSection?.style?.bgGradientAngle}
                onChange={(v) => onStyleChange("bgGradientAngle", v)}
              />
            </div>
          )}
        </div>
      </EditorGroup>

      <EditorGroup
        title={t("sectionModal.typography.title", "Typography")}
        subtitle={t(
          "sectionModal.typography.help",
          "Control alignment, colors, and fonts"
        )}
        defaultOpen
      >
        <div className="space-y-5">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.typography.titleColor", "Title Color")}
              type="color"
              value={editedSection?.style?.titleColor}
              onChange={(v) => onStyleChange("titleColor", v)}
            />
            <Field
              label={t(
                "sectionModal.typography.subtitleColor",
                "Subtitle Color"
              )}
              type="color"
              value={editedSection?.style?.subtitleColor}
              onChange={(v) => onStyleChange("subtitleColor", v)}
            />
          </div>

          {canAlign && (
            <LayoutAlignmentSelector
              value={alignmentValue}
              onChange={setAlignment}
              t={t}
            />
          )}

          <FontSelector
            value={editedSection?.style?.fontFamily || "Assistant"}
            onChange={(v) => onStyleChange("fontFamily", v)}
          />
        </div>
      </EditorGroup>

      <EditorGroup
        title={t("sectionModal.buttons.title", "Buttons")}
        subtitle={t(
          "sectionModal.buttons.help",
          "Button colors for this section only"
        )}
        defaultOpen={false}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field
            label={t(
              "sectionModal.buttons.primaryBg",
              "Primary Background"
            )}
            type="color"
            value={editedSection?.style?.primaryBtnBg}
            onChange={(v) => onStyleChange("primaryBtnBg", v)}
          />
          <Field
            label={t("sectionModal.buttons.primaryText", "Primary Text")}
            type="color"
            value={editedSection?.style?.primaryBtnText}
            onChange={(v) => onStyleChange("primaryBtnText", v)}
          />
          <Field
            label={t(
              "sectionModal.buttons.secondaryBorder",
              "Secondary Border"
            )}
            type="color"
            value={editedSection?.style?.secondaryBtnBorder}
            onChange={(v) => onStyleChange("secondaryBtnBorder", v)}
          />
          <Field
            label={t(
              "sectionModal.buttons.secondaryText",
              "Secondary Text"
            )}
            type="color"
            value={editedSection?.style?.secondaryBtnText}
            onChange={(v) => onStyleChange("secondaryBtnText", v)}
          />
          <Field
            label={t(
              "sectionModal.buttons.secondaryBg",
              "Secondary Background"
            )}
            type="color"
            value={editedSection?.style?.ctaSecondaryBtnBg}
            onChange={(v) => onStyleChange("ctaSecondaryBtnBg", v)}
          />
        </div>
      </EditorGroup>
    </>
  );
}